/**
 * PageTitle — the page-level `<h1>`, as a Fluent typography component carrying
 * the Utah Health brand treatment (UPPERCASE, 2rem, letter-spacing) so it no
 * longer depends on the global `h1` element CSS. Renders a semantic `<h1>`.
 *
 *   <PageTitle>Dashboard</PageTitle>
 *
 * The brand props are re-asserted here (they override Fluent's Title1 ramp) so
 * every page title lands at the same size and treatment.
 */

import { Title1, makeStyles, mergeClasses, tokens } from '@fluentui/react-components';
import type { ComponentProps } from 'react';

const useStyles = makeStyles({
  pageTitle: {
    fontSize: '2rem',
    fontWeight: 500,
    lineHeight: 1.2,
    textTransform: 'uppercase',
    letterSpacing: '0.1em',
    marginTop: 0,
    marginBottom: tokens.spacingVerticalXS,
  },
});

export function PageTitle({ className, ...props }: ComponentProps<typeof Title1>) {
  const styles = useStyles();
  return <Title1 as="h1" className={mergeClasses(styles.pageTitle, className)} {...props} />;
}

export default PageTitle;
